__turbopack_context__.v({
  "categoryButton": "category-button-module__U1hYuq__categoryButton",
  "selected": "category-button-module__U1hYuq__selected",
});
